export const buildClassStudentsForShareDownload = (
  allAssignedStudents = [],
  studentsSubmissions = [],
) => {
  const submissionsByStudentId = new Map();
  studentsSubmissions
    .filter((entry) => entry?.status !== 'DRAFT' && entry?.status !== 'DELETED' && entry?.studentId)
    .forEach((entry) => {
      const ids = submissionsByStudentId.get(entry.studentId) || [];
      if (entry.submissionId && !ids.includes(entry.submissionId)) ids.push(entry.submissionId);
      submissionsByStudentId.set(entry.studentId, ids);
    });

  const seen = new Set();
  const roster = [];

  (allAssignedStudents || []).forEach((student) => {
    const id = student?.id ?? student?.studentId;
    if (!id || seen.has(id)) return;
    seen.add(id);
    roster.push({
      id,
      name: student.name || student.studentName || 'Student Name',
      studentName: student.studentName || student.name || 'Student Name',
      submissionId: submissionsByStudentId.get(id)?.[0] || null,
      submissionIds: submissionsByStudentId.get(id) || [],
    });
  });

  studentsSubmissions
    .filter((entry) => entry?.status !== 'DRAFT' && entry?.status !== 'DELETED' && entry?.studentId)
    .forEach((entry) => {
      if (seen.has(entry.studentId)) return;
      seen.add(entry.studentId);
      roster.push({
        id: entry.studentId,
        name: entry.studentName || 'Student Name',
        studentName: entry.studentName || 'Student Name',
        submissionId: submissionsByStudentId.get(entry.studentId)?.[0] || null,
        submissionIds: submissionsByStudentId.get(entry.studentId) || [],
      });
    });

  return roster.sort((a, b) => a.name.localeCompare(b.name));
};
